import loadable from '@loadable/component';
/* istanbul ignore next */
export const NewbuildingMortgageSectionLoadable = loadable(() => import('./NewbuildingMortgageSectionContainer'), {
  resolveComponent: ({ NewbuildingMortgageSectionContainer }) => NewbuildingMortgageSectionContainer,
});
